import React from "react";
import { Col } from "reactstrap";
import DashPanel from "../common/DashPanel";
import SectionTitle from "../common/SectionTitle";
import StatBadgeRow from "../common/StatBadgeRow";
import ProgressRow from "../common/ProgressRow";
import { fmtINR, fmtNum } from "../../utils/formatters";
import { T } from "../../constants/theme";
import { erpSaleData } from "../../data/dashboardMockData";

const MODULE_COLORS = [T.blue, T.green, T.teal, T.orange, T.purple];

const ERPSection = ({ loading }) => (
  <Col xl={6} className="d-flex">
    <DashPanel
      title="ERP Sale"
      icon="bx bx-bar-chart-alt-2"
      iconColor={T.blue}
      loading={loading}
    >
      <StatBadgeRow
        items={[
          { label: "Total Bills", value: fmtNum(erpSaleData.totalBills), color: T.blue },
          { label: "Total Revenue", value: fmtINR(erpSaleData.totalAmount), color: T.green },
        ]}
        loading={loading}
      />

      <SectionTitle>Revenue by Module</SectionTitle>
      {erpSaleData.modules.map((m, i) => (
        <ProgressRow
          key={i}
          label={m.module}
          value={fmtNum(m.bills)}
          max={erpSaleData.totalBills || 1}
          rawValue={m.bills}
          color={MODULE_COLORS[i % 5]}
          badge={fmtINR(m.amount)}
          loading={loading}
        />
      ))}
    </DashPanel>
  </Col>
);

export default ERPSection;
